<template>
  <div>
    <v-card>
      <v-toolbar flat color="white">
        <v-toolbar-title>User Management</v-toolbar-title>
        <v-spacer />
        <v-btn color="secondary" dark @click="addUserDialog = true">
          Add User
        </v-btn>
      </v-toolbar>
      <v-data-table :headers="headers" :items="listData" :pagination.sync="pagination" :total-items="totalRecords" :loading="loading" :rows-per-page-items="rowsPerPageItems">
        <v-progress-linear slot="progress" color="secondary" indeterminate />
        <template slot="items" slot-scope="props">
          <td>{{ props.item.fullName }}</td>
          <td>{{ props.item.email }}</td>
          <td>
            <span v-if="props.item.lastLogin">
              {{ props.item.lastLogin | formatDate }}
            </span>
          </td>

          <td class="text-xs-center">
            <v-icon v-if="props.item.passwordExpired" color="green">
              fas fa-check
            </v-icon>
            <v-icon v-if="!props.item.passwordExpired" color="red">
              fas fa-times
            </v-icon>
          </td>

          <td class="text-xs-right">
            <v-icon class="mr-3" @click="editUserRolesPermissions(props.item)">
              fas fa-shield-alt
            </v-icon>
            <v-icon class="mr-3" @click="resetUserPassword(props.item)">
              fas fa-key
            </v-icon>
            <v-icon class="mr-3" @click="editUser(props.item)">
              far fa-edit
            </v-icon>
            <v-icon @click="deleteUser(props.item)">
              far fa-trash-alt
            </v-icon>
          </td>
        </template>
      </v-data-table>
    </v-card>

    <reset-password :user.sync="selectedUser" :dialog.sync="resetPasswordDialog" @getUsers="getUsers" />
    <edit-user :user.sync="selectedUser" :dialog.sync="editUserDialog" @getUsers="getUsers" />
    <add-user :dialog.sync="addUserDialog" @getUsers="getUsers" />
    <edit-permissions-roles :user.sync="selectedUser" :dialog.sync="permissionsRolesSideDrawer" :companies="companies" @getUsers="getUsers" />
  </div>
</template>

<script>
  import axios from 'axios';
  import ResetPassword from './components/ResetPassword.vue';
  import EditUser from './components/EditUser.vue';
  import AddUser from './components/AddUser.vue';
  import EditPermissionsRoles from './components/EditPermissionsRoles.vue';

  export default {
    parent: true,

    components: {
      ResetPassword,
      EditUser,
      AddUser,
      EditPermissionsRoles,
    },

    data: () => ({
      loading: true,
      listData: [],
      totalRecords: 0,
      rowsPerPageItems: [20, 50, 75, 100],
      pagination: {
        descending: false, page: 1, rowsPerPage: 20, sortBy: 'id', totalItems: 0,
      },
      headers: [
        { text: 'Name', value: 'firstName', align: 'left' },
        { text: 'Email', value: 'email', align: 'left' },
        { text: 'Last Login', value: 'lastLogin', align: 'left' },
        {
          text: 'Password Expired', align: 'passwordExpired', sortable: false,
        },
        {
          align: 'right', sortable: false,
        },
      ],
      editUserDialog: false,
      addUserDialog: false,
      selectedUser: null,
      resetPasswordDialog: false,
      permissionsRolesSideDrawer: false,
      companies: [],
    }),

    watch: {
      pagination: {
        handler() {
          this.getUsers();
        },
        deep: true,
      },
    },

    mounted() {
      this.getUsers();
      this.getCompanies();
    },

    methods: {
      async getUsers() {
        const {
          sortBy, descending, page, rowsPerPage,
        } = this.pagination;

        this.loading = true;
        const { data } = await axios.get(`/api/system/user-management/users?currentPage=${page}&pageSize=${rowsPerPage}`);
        this.listData = data.resultItems;
        this.totalRecords = data.totalRecords;
        this.loading = false;
      },

      async getCompanies() {
        const { data } = await axios.get('/api/system/user-management/users/companies');
        this.companies = data;
      },

      editUser(user) {
        this.selectedUser = user;
        this.editUserDialog = true;
      },

      resetUserPassword(user) {
        this.selectedUser = user;
        this.resetPasswordDialog = true;
      },

      editUserRolesPermissions(user) {
        this.selectedUser = user;
        this.permissionsRolesSideDrawer = true;
      },

      async deleteUser(user) {
        const result = confirm('Are you sure you want to delete this item?'); // eslint-disable-line
        if (result) {
          await axios.delete(`/api/system/user-management/users/${user.id}`);
          await this.getUsers();
        }
      },
    },
  };
</script>